import { render } from "./TaskParameters.vue?vue&type=template&id=b9fd2242"
import script from "./TaskParameters.vue?vue&type=script&lang=js"
export * from "./TaskParameters.vue?vue&type=script&lang=js"

import "./TaskParameters.vue?vue&type=style&index=0&id=b9fd2242&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__